import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentIciciStatus: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);

  const status = params.get("status");
  const refNo = params.get("refNo");
  const message = params.get("message");

  const isSuccess = status === "success";

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f6fa",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "420px",
          background: "white",
          borderRadius: "12px",
          padding: "32px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: "48px", marginBottom: "16px" }}>
          {isSuccess ? "✅" : "❌"}
        </div>

        <h2 style={{ marginBottom: "10px" }}>
          {isSuccess ? "Payment Successful" : "Payment Failed"}
        </h2>

        <p style={{ color: "#555", marginBottom: "10px" }}>
          {message || "Payment status updated"}
        </p>

        {refNo && (
          <p style={{ fontSize: "14px", color: "#777" }}>
            Reference No: <strong>{refNo}</strong>
          </p>
        )}

        <button
          onClick={() => navigate("/")}
          style={{
            marginTop: "24px",
            padding: "12px 20px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            background: isSuccess ? "#16a34a" : "#dc2626",
            color: "white",
            fontWeight: 600,
          }}
        >
          Go Home
        </button>
      </div>
    </div>
  );
};

export default PaymentIciciStatus;